/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'dialog-titlebar',
	templateUrl: './dialog-titlebar.component.html',
	styleUrls: ['./dialog-titlebar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogTitlebarComponent {
	@Input() public title: string;
	@Input() public icon = 'close';
	@Input() public showIconButton = true;
	@Input() public isCloseButton = true;
}
